import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';
import {IAppValidator} from './validator';

export const regexErrorKey = 'regexErrorKey';

export class PatternValidator implements IAppValidator {
  execute(configurationValue: any): ValidatorFn {
    return (control: AbstractControl): ValidationErrors => {
      const value = control?.value ?? null;
      const regex = new RegExp(configurationValue, 'i');

      if (value){
        if (!regex.exec(value)){
          return {[regexErrorKey]: 'Campo inválido'};
        }
      } else {
        if (!regex.exec("")){
          return {[regexErrorKey]: 'Campo inválido'};
        }
      }

      return {};
    };
  }
}

export const patternValidator = new PatternValidator();
